import { frontendURL } from 'dashboard/helper/URLHelper.js';

import FormsRouteView from './pages/FormsRouteView.vue';
import FormsIndex from './pages/FormsIndex.vue';
import FormEditor from './pages/FormEditor.vue';
import FormSubmissions from './pages/FormSubmissions.vue';

const meta = {
  permissions: ['administrator', 'agent', 'form_view'],
};

const formsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/forms'),
      component: FormsRouteView,
      children: [
        {
          path: '',
          name: 'forms_index',
          meta,
          component: FormsIndex,
        },
        {
          path: 'new',
          name: 'forms_new',
          meta: { permissions: ['administrator'] },
          component: FormEditor,
        },
        {
          path: ':formId/edit',
          name: 'forms_edit',
          meta: { permissions: ['administrator'] },
          component: FormEditor,
          props: true,
        },
        {
          path: ':formId/submissions',
          name: 'forms_submissions',
          meta,
          component: FormSubmissions,
          props: true,
        },
      ],
    },
  ],
};

export default formsRoutes;
